// extracted by mini-css-extract-plugin
export default {"root":"AppShell_root__MjiOq","fabs":"AppShell_fabs__eHKHI"};